module.exports = __webpack_public_path__ + "img/sankaku_13_red.3fd906d0.png";